/**
 * Created by xixue on 2019/7/4.
 */
import axios from 'axios'
import qs from 'qs'
import { logHost } from '@/utils/hostsconfig'

const connectlog = (msg, err, connectInfo) => {
  const logMsg = {
    'event': 'SUPERVISE_TEACHER_LOGIN',
    'role': 'TEACHER', // (STUDENT—学生, TEACHER—分析员, HEADMASTER—校长, OPERATOR—运营…),
    'teacher_id': connectInfo.teacher_id,
    'subject_id': connectInfo.subject_id,
    'school_id': connectInfo.school_id,
    'nick': connectInfo.nick,
    'user_agent': navigator.userAgent,
    'app_type': connectInfo.app_type, // (1: 线上, 2:线下）
  }

  let connMsg = null

  if (msg == 'connect_timeout' || msg == 'connect_error') {
    connMsg = Object.assign({}, logMsg, {
      "conn_msg": JSON.stringify({
        'msg_type': msg,
        'msg': err.message,
        'stack':JSON.stringify(err.stack)
      }),
      "conn_status": 0, //连接状态（0：失败，1：成功）
    })
  } else if(msg == 'connected') {
    connMsg = Object.assign({}, logMsg, {
      "conn_msg": msg,
      "conn_status": 1, //连接状态（0：失败，1：成功）
    })
  }
  // console.log({connectInfo})
  // console.log(qs.stringify(connMsg))
  // axios.post(`${logHost}/v1/report/common`, )
  //   .then(function (response) {
  //     console.log(response);
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   });
  var img = new Image();
  img.src = `${logHost}/v1/report/common?${qs.stringify(connMsg)}` ;
}

export default connectlog



// WEBPACK FOOTER //
// ./src/utils/connectlog.js